document.addEventListener('DOMContentLoaded', function() {

  /* 카드 헤더 추가 */
  const productListColumns = document.querySelectorAll(".list-product-items .m-mixed-layout__inner .m\\:column");
  productListColumns.forEach(column => {
      const nameElement = column.querySelector(".m-product-card__name");
      if (!nameElement) return;

      const text = nameElement.textContent;
      const match = text.match(/\[([^\]]+)\]/);
      const labelText = match ? `[${match[1]}]` : "[單品]";

      const topTitle = document.createElement("div");
      topTitle.className = "top_title";
      topTitle.textContent = labelText;

      column.insertBefore(topTitle, column.firstChild);
  });


  // 1. 안전한 디코딩 함수
  function getSafeDecodedUrl() {
    try {
      return decodeURIComponent(window.location.href).toLowerCase();
    } catch (e) {
      return window.location.href.toLowerCase();
    }
  }

  // 정규화된 URL (공백, 하이픈 제거)
  const currentUrl = getSafeDecodedUrl().replace(/[\s-]/g, '');

  const cateHeaders = document.querySelectorAll('.m-collection-card__inner');
  const tabHeaders = document.querySelectorAll('.m-tab-header'); // 탭 요소 선택자 확인 필요

  // --- Collection Card 처리 ---
  cateHeaders.forEach((cate, index) => {
    const cateText = cate.textContent.trim().toLowerCase().replace(/[\s-]/g, '');

    if (cateText.length > 0 && currentUrl.includes(cateText)) {
      cate.classList.add('active');
    }

    // frontpage 예외 처리
    if (currentUrl.includes('frontpage') && index === 1) {
      cate.classList.add('active');
    }

    cate.addEventListener('click', function () {
      const link = cate.querySelector('a.m-collection-card__link');
      if (link && link.href) {
        window.location.href = link.href;
      }
    });
  });

  // --- Product Tabs 처리 ---
  tabHeaders.forEach((tab, index) => {
    // 탭 텍스트 정규화
    const tabText = tab.textContent.trim().toLowerCase().replace(/[\s-]/g, '');
    
    // 2. 탭 텍스트가 URL에 포함되어 있는지 확인
    if (tabText.length > 0 && currentUrl.includes(tabText)) {
      tab.click();
    }
    
    // frontpage일 때 2번째 탭 강제 클릭
    if (currentUrl.includes('frontpage') && index === 1) {
      tab.click();
    }
  });



  if (window.innerWidth > 1024) {
      // 1. 설정 데이터
      const categoryMap = [
          {
              parent: 'LIP',
              children: ['LIPTIQUE', 'LIP OIL', 'LIP PENCIL', 'SLAYN HYPER GLOW', 'SLAYN POWDER MIXING WATER TINT', 'SLAYN AIR BLUR TINT']
          }
      ];

      const tabWrapper = document.querySelector('.m-section__tabs'); // 탭들을 감싸는 부모 컨테이너
      const allItems = document.querySelectorAll('.list-product-items .m-section-my .m-section__header .m-section__tabs a');

      // 2. 구조 변경 로직 (최초 1회 실행)
      categoryMap.forEach(category => {
          let parentElement = null;
          const childrenToMove = [];

          allItems.forEach(item => {
              const text = item.textContent.trim();
              if (text === category.parent) {
                  parentElement = item;
                  item.classList.add('parent-collection');
              } else if (category.children.includes(text)) {
                  childrenToMove.push(item);
                  item.classList.add('child-collection');
              }
          });

          if (parentElement && childrenToMove.length > 0) {
              // 텍스트 감싸기
              const parentTextDiv = document.createElement('div');
              parentTextDiv.classList.add('parent-text');
              parentTextDiv.textContent = category.parent;
              parentElement.textContent = ''; 
              parentElement.appendChild(parentTextDiv);

              // 자식 이동
              const childContainer = document.createElement('div');
              childContainer.classList.add('child-container');
              childrenToMove.forEach(child => childContainer.appendChild(child));
              parentElement.appendChild(childContainer);
          }
      });

      // 3. Active 클래스 동기화 함수
      function updateTabStatus() {
          // 각 카테고리별로 체크
          categoryMap.forEach(category => {
              const parent = Array.from(allItems).find(el => el.classList.contains('parent-collection') && el.innerText.includes(category.parent));
              if (!parent) return;

              const children = Array.from(parent.querySelectorAll('.child-collection'));
              const hasActiveChild = children.some(child => child.classList.contains('active'));

              if (hasActiveChild) {
                  parent.classList.add('active');
              } else {
                  // 다른 일반 메뉴(HOME 등)가 active인지 확인
                  const isOtherActive = Array.from(allItems).some(item => {
                      const isMyFamily = (item === parent || children.includes(item));
                      return !isMyFamily && item.classList.contains('active');
                  });

                  if (isOtherActive) {
                      parent.classList.remove('active');
                  }
              }
          });
      }

      // 4. 이벤트 리스너: 클릭 시점에 상태 업데이트 (약간의 지연을 주어 시스템 클래스 변경 후 실행)
      if (tabWrapper) {
          tabWrapper.addEventListener('click', () => {
              setTimeout(updateTabStatus, 50); 
          });
      }

      // 초기 로드 시 한 번 실행
      updateTabStatus();
  }


  // 모바일 환경
  if (window.innerWidth <= 1024) {
      // 1. 필요한 요소 선택
      const container = document.querySelector('.m-section__tabs');
      const wrapper = document.querySelector('.m-tabs__wrapper');
      const slides = document.querySelectorAll('.m-tab-header');

      // 2. Swiper 필수 클래스 강제 삽입
      container.classList.add('swiper');
      wrapper.classList.add('swiper-wrapper');
      slides.forEach(slide => {
          slide.classList.add('swiper-slide');
      });

      // 3. Swiper 초기화
      const tabSwiper = new Swiper('.m-section__tabs.swiper', {
          spaceBetween: 10,
          slidesPerView: 6.5,
          freeMode: true,
          watchOverflow: true,
          observer: true, 
          observeParents: true,
      });

      // 1. 설정 데이터
      const moCategoryMap = [
          {
              parent: 'LIP',
              children: ['LIPTIQUE', 'LIP OIL', 'LIP PENCIL', 'SLAYN HYPER GLOW', 'SLAYN POWDER MIXING WATER TINT', 'SLAYN AIR BLUR TINT']
          }
      ];

      const tabWrapper = document.querySelector('.m-tabs__wrapper.swiper-wrapper'); 
      const allItems = document.querySelectorAll('.m-tab-header.swiper-slide');

      // 2. 구조 변경 로직
      if (tabWrapper && allItems.length > 0) {
          moCategoryMap.forEach(category => {
              let parentElement = null;
              const childrenToMove = [];

              allItems.forEach(item => {
                  const text = item.textContent.trim();
                  if (text === category.parent) {
                      parentElement = item;
                      item.classList.add('parent-collection');
                  } else if (category.children.includes(text)) {
                      childrenToMove.push(item);
                      item.classList.add('child-collection');
                  }
              });

              if (parentElement && childrenToMove.length > 0) {
                  // 부모 텍스트 처리
                  const parentText = parentElement.textContent.trim();
                  const parentTextDiv = document.createElement('div');
                  parentTextDiv.classList.add('parent-text');
                  parentTextDiv.textContent = parentText;
                  
                  parentElement.textContent = ''; 
                  parentElement.appendChild(parentTextDiv);

                  // 자식 요소들을 감쌀 컨테이너 생성 및 이동
                  const childContainer = document.createElement('div');
                  childContainer.classList.add('child-container');
                  
                  childrenToMove.forEach(child => {
                      // --- 추가된 기능: 자식 슬라이드의 텍스트를 span으로 감싸기 ---
                      const originalText = child.textContent.trim();
                      const textSpan = document.createElement('span');
                      textSpan.textContent = originalText;
                      
                      child.textContent = ''; // 기존 텍스트 제거
                      child.appendChild(textSpan); // span 삽입
                      // --------------------------------------------------
                      
                      childContainer.appendChild(child);
                  });
                  parentElement.appendChild(childContainer);
              }
          });
      }

      // 3. Active 클래스 동기화 함수 (이하 동일)
      function updateTabStatus() {
          moCategoryMap.forEach(category => {
              const parent = Array.from(allItems).find(el => 
                  el.classList.contains('parent-collection') && 
                  el.querySelector('.parent-text')?.textContent.trim() === category.parent
              );
              
              if (!parent) return;

              const children = Array.from(parent.querySelectorAll('.child-collection'));
              const hasActiveChild = children.some(child => 
                  child.classList.contains('active') || child.classList.contains('isActive')
              );

              if (hasActiveChild) {
                  parent.classList.add('active');
              } else {
                  const isOtherActive = Array.from(allItems).some(item => {
                      const isMyFamily = (item === parent || children.includes(item));
                      const activeState = item.classList.contains('active') || item.classList.contains('isActive');
                      return !isMyFamily && activeState;
                  });

                  if (isOtherActive) {
                      parent.classList.remove('active');
                  }
              }
          });
      }

      if (tabWrapper) {
          tabWrapper.addEventListener('click', () => {
              setTimeout(updateTabStatus, 100); 
          });
      }

      // 4. 활성화된 슬라이드로 이동시키는 함수
      function moveToActiveSlide() {
          // .active 또는 .isActive 클래스를 가진 슬라이드 찾기
          const activeIndex = Array.from(allItems).findIndex(slide => 
              slide.classList.contains('active') || slide.classList.contains('isActive')
          );

          if (activeIndex !== -1) {
              // 해당 인덱스로 슬라이드 이동 (300ms 속도)
              tabSwiper.slideTo(activeIndex - 1, 300);
          }
      }

      // 초기 로드 시 실행
      setTimeout(() => {
          updateTabStatus();
          moveToActiveSlide();
      }, 200); // 구조 변경 및 클래스 주입 시간을 고려해 약간의 지연시간 부여

      // 클릭 시에도 활성화된 곳으로 부드럽게 이동하고 싶다면
      if (tabWrapper) {
          tabWrapper.addEventListener('click', () => {
              setTimeout(() => {
                  updateTabStatus();
                  moveToActiveSlide();
              }, 150); 
          });
      }

  }

    
})